// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <div className="flex items-center justify-end">
      {/* {!matchesXs && <Search />} */}
      {!matchesXs && <Box sx={{ width: '100%', mr: 1 }} />}
      {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}

      {/* <Localization /> */}
      {/* <WalletWidget /> */}
      {/* {userData?.license === 'merchant' && <PriseenConnect />} */}
      {/* <Notification /> */}
      {!matchesXs && <Profile />}
      {matchesXs && <MobileSection />}
    </div>
  );
};

export default HeaderContent;
